import { render, staticRenderFns } from "./BatteryBaseMock.vue?vue&type=template&id=238440f4&scoped=true&"
import script from "./BatteryBaseMock.vue?vue&type=script&lang=ts&"
export * from "./BatteryBaseMock.vue?vue&type=script&lang=ts&"
import style0 from "./BatteryBaseMock.vue?vue&type=style&index=0&id=238440f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238440f4",
  null
  
)

export default component.exports